import { observer } from "mobx-react-lite";
import { RulerIcon } from "lucide-react";

import { AbsoluteNumericDistanceConfiguration } from "@/types/evaluate";
import { BlockProps } from "@/components/PowerBlock/Block";
import { withBlockStore } from "@/components/PowerBlock/Block/block-store";
import { createEmptySources } from "@/components/PowerBlock/Block/hooks";
import { useIsReadonly } from "@/components/PowerBlock/Block/readonly-context";
import SectionGroup from "@/components/PowerBlock/Block/SectionGroup";
import { DoubleSourceSelector } from "@/components/PowerBlock/Block/SourceSelectors";
import { createBlockSchema } from "@/components/PowerBlock/Block/validation/schemaBuilder";

const validationSchema = createBlockSchema<AbsoluteNumericDistanceConfiguration>()
  .requireName()
  .requireDoubleSource()
  .build();

const AbsoluteNumericDistanceBlockCore = observer(
  ({
    sources = createEmptySources(),
  }: Omit<BlockProps<AbsoluteNumericDistanceConfiguration>, "DefaultFields">) => {
    const isReadonly = useIsReadonly();

    return (
      <SectionGroup
        title="Data Sources"
        description="Select the numeric values to calculate distance between"
        icon={<RulerIcon className="h-4 w-4" />}
      >
        <DoubleSourceSelector
          sources={sources}
          firstName="Source"
          secondName="Target"
          firstValidationPath="configuration.sources.0"
          secondValidationPath="configuration.sources.1"
          disabled={isReadonly}
        />
      </SectionGroup>
    );
  },
);

export default withBlockStore<AbsoluteNumericDistanceConfiguration>(
  AbsoluteNumericDistanceBlockCore,
  {
    validationSchema,
  },
);
